import PackageJson from "../package.json" with { type: "json" };

export const VERSION = PackageJson.version;
